"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterceptorService = void 0;
class InterceptorService {
    interceptors = [];
    add(...interceptors) {
        this.interceptors.push(...interceptors);
    }
    clear() {
        this.interceptors.filter(() => true);
    }
    onSubscribe(subscribeReturn) {
        this.interceptors.forEach((interceptor) => interceptor.onSubscribe(subscribeReturn));
    }
    remove(...interceptors) {
        this.interceptors.filter((existsInterceptor) => {
            return interceptors.every((interceptor) => interceptor !== existsInterceptor);
        });
    }
}
exports.InterceptorService = InterceptorService;
